import {
    doNotModifyCodeAbove,
    doNotModifyCodeBelow,
} from "@js/educationContent/CairoMummiesContent/eduConstants";

export const lesson3DefaultStartCode = `// Remember the 'add' function from before? The 'add' function below does the exact same
// thing! If you leave out a semicolon at the end of the function, the function 
// returns the result of that statement. Pretty neat, eh?
//
// Young Starkling, Joe, tried to write his own 'sub' function, but his function
// won't compile. Can you help him out?

fn add(a: felt252, b: felt252) -> felt252 {
    a + b
}
${doNotModifyCodeAbove}`;

export const lesson3DefaultMiddleCode = `// TODO: Edit this function
fn sub(a, b) {
    a - b;
}
`;

export const lesson3DefaultEndCode = `${doNotModifyCodeBelow}
fn main() -> felt252 {
    add(3, 5);
    sub(11, 7)
}

#[test]
fn test_compile() {
    assert(1 == 1, 'Surprising');
    main();
} `;
